.card {
  align-items: flex-start;
  background: var(--color-tertiary-background);
  border-radius: 6px;
  display: flex;
  gap: 0.625rem;
  padding: 0.75rem 1.25rem;
}

.card :global(svg) {
  color: var(--color-border);
  flex-shrink: 0;
}

.content {
  min-width: 0;
}

.body {
  margin: 0;
}
